import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { forkJoin, from, Observable } from 'rxjs';
import {  map } from 'rxjs/operators';
import { URLS } from "../../../../config/api.config";
import { CommonService } from "../../../helpers/common.service";
import { HTTP } from "@awesome-cordova-plugins/http/ngx";
import { CustomEncryption } from "../../../../config/custom-encrypt";
import moment from "moment";
import { environment } from "../../../../environments/environment";
import { StorageServiceAAA } from "../../../helpers/aaa-storage.service";
import e from "express";

@Injectable()
export class GuestDashBoardService {
	private getBankName = URLS.getBankName;
	private fileUploadService = URLS.fileUploadService;
	private arnNodeUrl = URLS.arnNodeUrl;
	private generateTokenExtentedApi = URLS.generateTokenExtentedApi
	public options: any;
	private nativeHeaders: any = environment['nativeHeaders'];
	//private gatewaySubscriptionKey = environment['gatewaySubscriptionKey'];

	private userOnboard = URLS.userOnboard;
	private leadSearchToken = URLS.crmLogin;			
	private verifypan = URLS.verifyPan;
	private guestDetails = URLS.guestDetails;
	private GuestCaptureDetails = URLS.GuestCaptureDetails;
	private captureGuestPayment = URLS.captureGuestPayment;
	private VerifyGuestMobileOrEmail = URLS.VerifyGuestMobileOrEmail;
	private loginSearch = URLS.loginSearch;
	private gatewaySubscriptionKey: any = environment['gatewaySubscriptionKey'];
	// env:any;
	private proxyUpdateList = [
		'Ocp-Apim-Subscription-Key',
		'key',
		'Key',
		'CheckSum',
		'UserID',
		'Password',
		'VID',
		'UniqueKey',
		'UserName',
		'Content-Type',
		'UserKey'
	]

	 private keyMap = {
        ttKey: 'ttParams',
        marketKey: 'marketParams',
        verifyGuestKey: 'Verify_Guest_And_ExtendedApi',
        verifyRequestKey: 'VerifyRequestApi',
        tt: 'TT_OCP',
        aaaOcp: 'AAA_OCP',
        mfOcp: 'MF_OCP',
        investEdge2Ocp: 'investEdge2_OCP',
        mfCommonVid: 'mfCommonVid',
        globalChecksumKey: 'globalChecksumKey',
        clientTradesChecksum: 'clientTrades',
		'eaccount':'eaccount'
    }

	env:any = {
        ttParams: { key: this.keyMap.ttKey },
        marketParams: { key: this.keyMap.marketKey },
        verifyGuestandExtendedApi: { key: this.keyMap.verifyGuestKey },
        verifyRequestApi: { key: this.keyMap.verifyRequestKey },
        gatewaySubscriptionKey: {
            tt: this.keyMap.tt,
            aaa: this.keyMap.aaaOcp,
            mf: this.keyMap.mfOcp,
            investEdge2: this.keyMap.investEdge2Ocp,
			eaccount: this.keyMap.eaccount
        },
        mfCommonVid: { vid: this.keyMap.mfCommonVid },
        generalChecksumKey: {
            globalChecksumKey: this.keyMap.globalChecksumKey,
            clientTrades: this.keyMap.clientTradesChecksum
        },
        'headersParams-optionalHeaders': {
            UserId: 'headersParams_optionalHeaders_UserId',
            Password: 'headersParams_optionalHeaders_Password'
        }
    };

	constructor(private httpClient: HttpClient,
		private nativeHttp: HTTP,
		private commonService: CommonService,
		private cipherText: CustomEncryption,
	private storage: StorageServiceAAA) {
						
	}

	private buildConfig(url: string, extraUpdateList: string[] = []) {
		return {
			url: `${url}`,
			updateList: [...this.proxyUpdateList, ...extraUpdateList]
		}
	}

	public sendReqTOServer(params: any, config: any, reqHead: any): Observable<{}>{
		return this.httpClient.post('/api/secure/common-all-service', {
			params,
			config,
			reqHead
		})
	}

	public getUserOnboardData(mob: any): Observable<{}> {
		let params = {
			"MobileNo": mob,
			"Key": '',
			"AppName": 'AAA',
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.gatewaySubscriptionKey.aaa,
			'appID': this.commonService.get('appID') || ''
		};
		return this.sendReqTOServer(params, this.buildConfig(this.userOnboard.url), obj);
	}

	public getTokenforPANVerification(): Observable<{}> {

	return this.httpClient.post('/api/secure/generate-pan-token', {})
	}

	public verifyPanNo(data: any, cookievalue: string) {
		let params = {
			head: {
				"UniqueKey": "UniqueKey",
				"AppName": this.verifypan.appName,
				"AppVer": this.verifypan.appVer,
				"OsName": this.verifypan.osName
			}, "body": data
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key':"eaccount",
			'appID': this.commonService.get('appID') || '',
			'Authorization' : 'Bearer ' + cookievalue
		}

		return this.sendReqTOServer(params, this.buildConfig(`${this.verifypan.url}api/FranchiseeOnBoardingAPI/CheckPanExistV2`), obj);
	}

	public guestSaveDetails(params: any, formName: any) {
		let Token = this.commonService.get('JWTToken');
		let appID = this.commonService.get('appID') || ''
		return this.httpClient.post('/api/secure/save-guest-details', { params, formName, Token, appID })
	}

	public searchLeadToken(){
		let params = {};
		let obj = {
			'UserKey': 'guestUserKey',
			'Authorization': 'crmBasicAuth',
			'Ocp-Apim-Subscription-Key': this.gatewaySubscriptionKey.iiflcrm,
			'appID': this.commonService.get('appID') || ''
		};
		return this.sendReqTOServer(params, this.buildConfig(this.leadSearchToken.url, ['Authorization']), obj);
	}

	public guestCaptureStatus(endPoint: string, requestCode: string,env?:any) {
		// if(this.env == undefined || this.env == null){
        //     this.env = env
        // }
		let mobileNo = this.commonService.get('GuestMobileNumber')
		let checkSumKey = this.cipherText.generateCheckSumKey();
		let stringValue = `${mobileNo}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`
		mobileNo = this.cipherText.createChecksum(mobileNo, checkSumKey);

		let params = {
			"head": {
				"RequestCode": requestCode,
				"Key": this.env.verifyGuestandExtendedApi.key,
				"AppName": this.GuestCaptureDetails.appName,
				"AppVer": this.GuestCaptureDetails.appVer,
				"OsName": this.GuestCaptureDetails.osName,
				"CheckSum": stringValue,
				"CheckSumKey": checkSumKey,
				"Token": this.commonService.get('JWTToken')
			},
			"body": {
				'Mobilenumber': mobileNo
			}
		};

		let obj: any = {
			'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa,
			'appID': this.commonService.get('appID') || ''
		};
		return this.sendReqTOServer(params, this.buildConfig(`${this.GuestCaptureDetails.url}${endPoint}`), obj);
	}

	capturePayment(data:any){
		let checkSumKey =  this.cipherText.generateCheckSumKey();
		const stringValue = `${this.commonService.get('GuestMobileNumber')}_${data.PaymentID}_${data.OrderID}_${data.Status}_${data.Amount}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`
		data.MobileNo = this.cipherText.createChecksum(this.commonService.get('GuestMobileNumber'), checkSumKey);
		let params = { 
			"head": {
				"RequestCode": "SaveGuestPaymentdetails",
				"Key": this.captureGuestPayment.key,
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"CheckSum": stringValue,
				"CheckSumKey": checkSumKey,
				"Token":this.commonService.get('JWTToken')
			},
			"body": data
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa,
			'appID': this.commonService.get('appID') || ''
		};

		return this.sendReqTOServer(params, this.buildConfig(`${this.captureGuestPayment.url}`), obj);
	}

	public verifyEmail(params: any, cookievalue: any, checkSumString:any) {
		const UserName=  this.commonService.get('extUserName')
        const Token = this.commonService.get('extToken')
				return this.httpClient.post('/api/secure/verify-email',
					 { params, cookievalue, checkSumString,UserName, Token
					 })
	}


	public generateTokenExtented(){
		return this.httpClient.post('/api/secure/generate-email-token', {})
	}

	public arnNodeScrapping(id:any){
        const params = {
            id: id
        }
        let obj: any = {
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
            'appID': this.commonService.get('appID') || ''
        }
		return this.sendReqTOServer(params, this.buildConfig(this.arnNodeUrl.url), obj);
     }

	 public sendFileToserver( fromName: string, fileName?: any) {
		const appID =  this.commonService.get('appID')
		const mobileNumber = this.commonService.get('GuestMobileNumber')
		let token= this.commonService.get('JWTToken')
			return	this.httpClient.post('/api/secure/file-upload-guest', { fromName, fileName, appID, mobileNumber, token })
	}

	 public getBankNameDetails(item?: any) {
		let checkSumKey =  this.cipherText.generateCheckSumKey();
		const stringValue = `${this.commonService.get('GuestMobileNumber')}_${item}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`
		const MobileNo = this.cipherText.createChecksum(this.commonService.get('GuestMobileNumber'), checkSumKey);
		 let data ={
					"head": {
						"RequestCode": "GuestFileUpload",
						"Key": 'VerifyRequestApi',
						"AppName": this.getBankName.appName,
						"AppVer": "01",
						"OsName": "Android",
						"CheckSum": stringValue,
						"CheckSumKey": checkSumKey,
						"Token": this.commonService.get('JWTToken')
					},
					"body": {
						"Mobilenumber": MobileNo,
						"IFSCCode": this.cipherText.createChecksum(item, checkSumKey),
					}
				}
        let obj: any = {
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
            'appID': this.commonService.get('appID') || ''
        }

		return this.sendReqTOServer(data, this.buildConfig(this.getBankName.url), obj);
	}

	getDecryptedValue(data:any){
   
    return this.httpClient.post('/api/secure/decryptGuestLoginChecksum-service', { data})
 }
	
}
